(function () {
  var REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

  function prefersReducedMotion() {
    return window.matchMedia(REDUCED_MOTION).matches;
  }

  function getPanel(details) {
    return details.querySelector('.accordion__content');
  }

  function clearPanelStyles(panel) {
    panel.style.height = '';
    panel.style.opacity = '';
    panel.style.overflow = '';
    panel.style.transition = '';
  }

  function animateOpen(panel, type) {
    if (prefersReducedMotion()) return;

    if (type === 'fade') {
      panel.style.opacity = '0';
      panel.offsetHeight;
      panel.style.transition = 'opacity 0.3s ease';
      panel.style.opacity = '1';
      panel.addEventListener(
        'transitionend',
        function onEnd(event) {
          if (event.propertyName !== 'opacity') return;
          panel.removeEventListener('transitionend', onEnd);
          clearPanelStyles(panel);
        }
      );
      return;
    }

    panel.style.overflow = 'hidden';
    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.transition = 'height 0.3s ease';
    panel.style.height = panel.scrollHeight + 'px';
    panel.addEventListener(
      'transitionend',
      function onEnd(event) {
        if (event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        clearPanelStyles(panel);
      }
    );
  }

  function animateClose(panel, type, onDone) {
    if (prefersReducedMotion()) {
      onDone();
      return;
    }

    if (type === 'fade') {
      panel.style.transition = 'opacity 0.25s ease';
      panel.style.opacity = '0';
      panel.addEventListener(
        'transitionend',
        function onEnd(event) {
          if (event.propertyName !== 'opacity') return;
          panel.removeEventListener('transitionend', onEnd);
          onDone();
          clearPanelStyles(panel);
        }
      );
      return;
    }

    panel.style.overflow = 'hidden';
    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight;
    panel.style.transition = 'height 0.3s ease';
    panel.style.height = '0px';
    panel.addEventListener(
      'transitionend',
      function onEnd(event) {
        if (event.propertyName !== 'height') return;
        panel.removeEventListener('transitionend', onEnd);
        onDone();
        clearPanelStyles(panel);
      }
    );
  }

  function bindDetails(details) {
    if (details.dataset.accordionBound === 'true') return;
    details.dataset.accordionBound = 'true';

    var summary = details.querySelector('summary');
    if (!summary) return;

    summary.addEventListener('click', function (event) {
      if (prefersReducedMotion()) return;

      var type = details.dataset.accordionAnimation || 'slide';
      var panel = getPanel(details);
      if (!panel) return;

      event.preventDefault();

      if (details.open) {
        animateClose(panel, type, function () {
          details.open = false;
        });
      } else {
        details.open = true;
        animateOpen(panel, type);
      }
    });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('details[data-accordion-animation]').forEach(bindDetails);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
